(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 48312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(85320);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 85320:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(10092);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./styles/Home.module.css
var Home_module = __webpack_require__(214);
var Home_module_default = /*#__PURE__*/__webpack_require__.n(Home_module);
// EXTERNAL MODULE: ./components/Layout.tsx + 9 modules
var Layout = __webpack_require__(79560);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 1 modules
var Box = __webpack_require__(87357);
// EXTERNAL MODULE: ./components/layout/Footer.module.css
var Footer_module = __webpack_require__(14525);
var Footer_module_default = /*#__PURE__*/__webpack_require__.n(Footer_module);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./components/footer/legal.tsx
var legal = __webpack_require__(5888);
// EXTERNAL MODULE: ./components/footer/social.tsx
var social = __webpack_require__(5831);
// EXTERNAL MODULE: ./components/footer/badges_app.tsx
var badges_app = __webpack_require__(29031);
;// CONCATENATED MODULE: ./components/layout/Footer.tsx




// import useMediaQuery from '@mui/material/useMediaQuery'



function Footer() {
    /*
  const matches = useMediaQuery('(min-width:700px)')

  function ECommerce() {
    return (
      <div
        className={styles.footer__ecommerce}
      >
        <Image src={'/images/ecommercetrustmark.png'} alt="ecommerce trustmark" width={80} height={70} />
        <Image src={'/images/confianza-online.png'} alt="confianza online" width={70} height={70} />
      </div>
    )
  }

  function TrustpilotWidget() {
    return (
      <Image src="/images/trustpilot-widget-example.png" alt="trustpilot" width={140} height={70} />
    )
  }
  */ return /*#__PURE__*/ (0,jsx_runtime.jsxs)("footer", {
        className: (Footer_module_default()).footer,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                className: (Footer_module_default()).footer__links,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(social/* default */.Z, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(legal/* default */.Z, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(badges_app/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                href: "https://www.confianzaonline.es/empresas/syniva.htm",
                target: "_blank",
                rel: "noopener noreferrer",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    className: (Footer_module_default()).footer__trustseal,
                    src: "/images/confianza-online.png",
                    alt: "trustseal",
                    width: "85%",
                    height: "85%"
                })
            })
        ]
    });
}

// EXTERNAL MODULE: ./node_modules/swiper/react/swiper-react.js + 15 modules
var swiper_react = __webpack_require__(30719);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.min.css
var swiper_min = __webpack_require__(30933);
// EXTERNAL MODULE: ./node_modules/swiper/modules/pagination/pagination.min.css
var pagination_min = __webpack_require__(68770);
// EXTERNAL MODULE: ./node_modules/swiper/modules/navigation/navigation.min.css
var navigation_min = __webpack_require__(92);
// EXTERNAL MODULE: ./components/carousels/BannersCarousel.module.scss
var BannersCarousel_module = __webpack_require__(97489);
var BannersCarousel_module_default = /*#__PURE__*/__webpack_require__.n(BannersCarousel_module);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.esm.js + 90 modules
var swiper_esm = __webpack_require__(71911);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./lib/supabaseApi.ts
var supabaseApi = __webpack_require__(19627);
;// CONCATENATED MODULE: ./components/carousels/BannersCarousel.tsx









// TODO: Try to implement `fade` effect. It seems like there are many problems with it
// https://github.com/nolimits4web/swiper/issues/3622
function Carousel() {
    var ref = (0,react.useState)(), banners = ref[0], setBanners = ref[1];
    (0,react.useEffect)(function() {
        (0,supabaseApi/* getBanners */.Ey)().then(function(banners) {
            if (banners) {
                setBanners(banners);
            }
        });
    }, []);
    return banners ? /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
        slidesPerView: 1,
        autoplay: {
            delay: 5000,
            disableOnInteraction: true
        },
        spaceBetween: 100,
        pagination: {
            clickable: true
        },
        modules: [
            swiper_esm/* Autoplay */.pt,
            swiper_esm/* Pagination */.tl,
            swiper_esm/* Navigation */.W_
        ],
        className: (BannersCarousel_module_default()).swiper,
        direction: "vertical",
        breakpoints: {
            465: {
                direction: "horizontal",
                slidesPerView: banners.length
            },
            768: {
                slidesPerView: banners.length,
                direction: "horizontal",
                spaceBetween: 30
            }
        },
        children: banners && banners.map(function(child, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                        modules: [
                            swiper_esm/* Autoplay */.pt,
                            swiper_esm/* Pagination */.tl,
                            swiper_esm/* Navigation */.W_
                        ],
                        slidesPerView: 1,
                        autoplay: {
                            // delay: 2000, //TODO: Refactor this. Default component value is 3000
                            disableOnInteraction: true
                        },
                        loop: child.length > 1,
                        spaceBetween: 100,
                        pagination: false,
                        className: (BannersCarousel_module_default()).swiper__child,
                        direction: "vertical",
                        breakpoints: {
                            465: {
                                direction: "horizontal",
                                slidesPerView: 1,
                                autoplay: {
                                    disableOnInteraction: false
                                }
                            },
                            768: {
                                slidesPerView: 1,
                                direction: "horizontal",
                                spaceBetween: 30,
                                autoplay: {
                                    disableOnInteraction: false
                                }
                            }
                        },
                        children: child.length !== 0 && child.map(function(banner, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                                className: (BannersCarousel_module_default()).slide,
                                style: {
                                    backgroundImage: 'url("'.concat(banner.banner_url, '")'),
                                    backgroundSize: "cover",
                                    backgroundRepeat: "no-repeat",
                                    backgroundPosition: "center",
                                    cursor: banner.redirect_url ? "pointer" : ""
                                },
                                onClick: function() {
                                    return (banner === null || banner === void 0 ? void 0 : banner.redirect_url) && window.location.replace(banner.redirect_url);
                                }
                            }, index);
                        })
                    })
                }, index)
            });
        })
    }) : null;
}

// EXTERNAL MODULE: ./node_modules/@mui/system/esm/Container/Container.js
var Container = __webpack_require__(32045);
// EXTERNAL MODULE: ./components/carousels/LogosCarousel.module.css
var LogosCarousel_module = __webpack_require__(75277);
var LogosCarousel_module_default = /*#__PURE__*/__webpack_require__.n(LogosCarousel_module);
// EXTERNAL MODULE: ./node_modules/@mui/material/useMediaQuery/useMediaQuery.js
var useMediaQuery = __webpack_require__(98396);
// EXTERNAL MODULE: ./lib/constants.ts
var constants = __webpack_require__(59953);
// EXTERNAL MODULE: ./lib/supabaseClient.ts + 43 modules
var supabaseClient = __webpack_require__(66508);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./node_modules/@mui/material/Rating/Rating.js + 4 modules
var Rating = __webpack_require__(44612);
// EXTERNAL MODULE: ./node_modules/@mui/material/Button/Button.js + 1 modules
var Button = __webpack_require__(11057);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js + 3 modules
var useTranslation = __webpack_require__(77058);
;// CONCATENATED MODULE: ./components/mobile/downloadAppBanner.tsx








function DownloadAppBanner() {
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var ref = (0,react.useState)(90), visibility = ref[0], setVisibility = ref[1];
    var ref1 = (0,react.useState)(), synivaScore = ref1[0], setSynivaScore = ref1[1];
    var ref2 = (0,react.useState)(false), isWebView = ref2[0], setIsWebView = ref2[1];
    var getSynivaScore = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var data;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            supabaseClient/* default.from */.Z.from("variables").select("value").eq("name", [
                                "iphone",
                                "iphone",
                                "safari"
                            ].includes(window.navigator.userAgent.toLowerCase()) ? constants/* APP_STORE_SCORE */.YC : constants/* PLAY_STORE_SCORE */.mA).single()
                        ];
                    case 1:
                        data = _state.sent().data;
                        setSynivaScore(data === null || data === void 0 ? void 0 : data.value);
                        return [
                            2
                        ];
                }
            });
        });
        return function getSynivaScore() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        getSynivaScore();
        checkifIsWebView();
    }, []);
    var checkifIsWebView = function() {
        var cookies = document.cookie.split(";");
        var versionToCheck = cookies.find(function(cookie) {
            return cookie.includes("syniva-app-version");
        });
        var version = versionToCheck === null || versionToCheck === void 0 ? void 0 : versionToCheck.split("=")[1];
        if (version && version !== "") {
            setIsWebView(true);
        }
    };
    if (isWebView) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        style: {
            position: "fixed",
            backgroundColor: "white",
            width: "".concat(visibility, "%"),
            height: "5.2rem",
            paddingTop: "0.5rem",
            paddingLeft: "0.5rem",
            borderEndEndRadius: "10px",
            borderTopRightRadius: "10px"
        },
        children: visibility > 50 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    style: {
                        display: "flex",
                        justifyContent: "space-around"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            style: {
                                display: "flex",
                                width: "60%",
                                marginBottom: "0.5rem"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: "/images/Syniva-App-Logo.jpg",
                                    alt: "App-Logo",
                                    width: 50
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    style: {
                                        marginLeft: "0.5rem",
                                        display: "grid"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            style: {
                                                fontSize: "14px",
                                                marginTop: "2px"
                                            },
                                            children: t("mobileBanner.bannerText")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Rating/* default */.Z, {
                                            name: "read-only-score",
                                            value: synivaScore,
                                            precision: 0.5,
                                            readOnly: true
                                        }, synivaScore)
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            style: {
                                width: "40%",
                                height: "2.5rem",
                                display: "flex",
                                justifyContent: "space-between"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    style: {
                                        marginTop: "0.5rem",
                                        fontSize: "12px",
                                        minWidth: "80%",
                                        color: "#0e046d",
                                        backgroundColor: "#c3fb00",
                                        fontWeight: "bold"
                                    },
                                    onClick: function() {
                                        location.href = "https://onelink.to/syniva";
                                    },
                                    children: t("mobileBanner.downloadAppText")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    variant: "text",
                                    style: {
                                        marginTop: "0.5rem",
                                        minWidth: "20%",
                                        fontWeight: "bold",
                                        fontSize: "15px",
                                        color: "#0e046d"
                                    },
                                    onClick: function() {
                                        setVisibility(10);
                                    },
                                    children: "X"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                    style: {
                        display: "flex",
                        marginTop: "-0.4rem",
                        fontSize: "10px"
                    },
                    children: t("mobileBanner.infoText")
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                variant: "text",
                style: {
                    marginTop: "0.3rem",
                    minWidth: "20%",
                    fontWeight: "bold",
                    fontSize: "20px",
                    color: "#0e046d"
                },
                onClick: function() {
                    setVisibility(90);
                },
                children: t("mobileBanner.expandIcon")
            })
        })
    });
}

;// CONCATENATED MODULE: ./components/carousels/LogosCarousel.tsx













function LogosCarousel() {
    var ref = (0,react.useState)(), marketplaces = ref[0], setMarketPlaces = ref[1];
    var isMobile = (0,useMediaQuery/* default */.Z)("(max-width:".concat(constants/* MOBILE_WIDTH_LIMIT */.x9, "px)"));
    (0,react.useEffect)(function() {
        (0,supabaseApi/* getMarketplaces */.ve)().then(function(marketplaces) {
            if (!marketplaces) return;
            var final = marketplaces.filter(function(mk) {
                return mk.is_in_home;
            });
            setMarketPlaces(final);
        });
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
        className: (LogosCarousel_module_default()).container,
        children: [
            isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    position: "absolute",
                    bottom: 0,
                    marginBottom: "75%",
                    marginLeft: "-1rem",
                    zIndex: "1"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DownloadAppBanner, {})
            }),
            marketplaces && /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                slidesPerView: "auto",
                autoplay: {
                    delay: 2000,
                    disableOnInteraction: false
                },
                loop: true,
                spaceBetween: 70,
                modules: [
                    swiper_esm/* Autoplay */.pt,
                    swiper_esm/* Pagination */.tl,
                    swiper_esm/* Navigation */.W_
                ],
                className: (LogosCarousel_module_default()).swiper,
                children: marketplaces === null || marketplaces === void 0 ? void 0 : marketplaces.map(function(marketplace, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                        className: (LogosCarousel_module_default()).slide,
                        style: {
                            backgroundImage: 'url("'.concat(marketplace.logo_url, '")'),
                            backgroundSize: "contain",
                            backgroundRepeat: "no-repeat",
                            backgroundPosition: "center center"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: marketplace.url || "#",
                            style: {
                                width: "100%",
                                height: "100%",
                                cursor: "pointer"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {})
                        })
                    }, index);
                })
            })
        ]
    });
}

// EXTERNAL MODULE: ./node_modules/axios/lib/axios.js + 40 modules
var axios = __webpack_require__(6154);
// EXTERNAL MODULE: ./node_modules/@mui/material/IconButton/IconButton.js + 1 modules
var IconButton = __webpack_require__(93946);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Cancel.js
var Cancel = __webpack_require__(44510);
;// CONCATENATED MODULE: ./components/mobile/update_page.tsx
/* provided dependency */ var process = __webpack_require__(83454);






function UpdatePage() {
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var ref = (0,react.useState)(false), showUpdate = ref[0], setShowUpdate = ref[1];
    var ref1 = (0,react.useState)("android"), device = ref1[0], setDevice = ref1[1];
    (0,react.useEffect)(function() {
        var userAgent = navigator.userAgent.toLowerCase();
        var isAndroid = userAgent.includes("android");
        var isIOS = userAgent.includes("iphone") || userAgent.includes("ipad");
        if (isAndroid) {
            setDevice("android");
        } else if (isIOS) {
            setDevice("ios");
        }
        var options = {
            method: "GET",
            url: process.env.NEXT_PUBLIC_URL_CHECK_VERSION ? process.env.NEXT_PUBLIC_URL_CHECK_VERSION : "/api/check-device-version"
        };
        axios/* default.request */.Z.request(options).then(function(response) {
            var ref;
            if ((response === null || response === void 0 ? void 0 : (ref = response.data) === null || ref === void 0 ? void 0 : ref.message) === "ko") {
                setShowUpdate(true);
            }
        }).catch(function(error) {
            setShowUpdate(false);
        });
    }, []);
    var handleShowUpdate = function() {
        setShowUpdate(false);
    };
    return showUpdate ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        style: {
            backgroundColor: "#ffffff",
            position: "relative",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: "1%"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                "aria-label": "close",
                size: "medium",
                style: {
                    position: "absolute",
                    top: 0,
                    right: 0
                },
                onClick: handleShowUpdate,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Cancel/* default */.Z, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    paddingTop: "30px"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    style: {
                        fontSize: "24px",
                        fontWeight: 700,
                        textAlign: "end"
                    },
                    children: t("pages.update_mobile.update_need")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    fontSize: "18px",
                    textAlign: "center",
                    padding: "18px"
                },
                children: t("pages.update_mobile.update_info")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                style: {
                    fontWeight: 200,
                    display: "flex",
                    flexDirection: "column",
                    paddingBottom: "30px"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                        style: {
                            fontSize: "24px",
                            textAlign: "center"
                        },
                        children: "syniva"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        style: {
                            fontSize: "18px",
                            textAlign: "center"
                        },
                        children: t("pages.update_mobile.update_hashtag")
                    })
                ]
            })
        ]
    }) : null;
}

// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./components/carousels/MainMobileCarousel.module.css
var MainMobileCarousel_module = __webpack_require__(41283);
var MainMobileCarousel_module_default = /*#__PURE__*/__webpack_require__.n(MainMobileCarousel_module);
// EXTERNAL MODULE: ./node_modules/@mui/material/Container/Container.js
var Container_Container = __webpack_require__(46574);
;// CONCATENATED MODULE: ./components/carousels/MainMobileCarousel.tsx







// import { Autoplay, Pagination, Navigation } from 'swiper'




// TODO: Try to implement `fade` effect. It seems like there are many problems with it
// https://github.com/nolimits4web/swiper/issues/3622
function MainMobileCarousel() {
    var ref = (0,react.useState)(null), images = ref[0], setImages = ref[1];
    var ref1 = (0,react.useState)(3), timeTransition = ref1[0], setTimeTransition = ref1[1];
    var ref2 = (0,react.useState)(true), loading = ref2[0], setLoading = ref2[1];
    (0,react.useEffect)(function() {
        (0,supabaseApi/* getMainImages */.c9)().then(function(imgs) {
            try {
                if (imgs && imgs[0] && imgs[0].value) {
                    var config = JSON.parse(imgs[0].value);
                    setImages(config.imgList);
                    setTimeTransition(config.timeTransition);
                    setLoading(false);
                }
            } catch (error) {
                setImages(null);
                setLoading(false);
            }
        });
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: loading ? null : images ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Container_Container/* default */.Z, {
            className: (MainMobileCarousel_module_default()).container,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                slidesPerView: "auto",
                autoplay: {
                    delay: images.length === 1 ? 3600 * 1000 : 1000 * timeTransition,
                    disableOnInteraction: false
                },
                loop: true,
                spaceBetween: 10,
                className: (MainMobileCarousel_module_default()).swiper,
                modules: [
                    swiper_esm/* Autoplay */.pt
                ],
                children: images === null || images === void 0 ? void 0 : images.map(function(img, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                        className: (MainMobileCarousel_module_default()).slide,
                        style: {
                            backgroundImage: 'url("'.concat(img).concat("?" + Date.now().toLocaleString(), '")'),
                            backgroundSize: "contain",
                            backgroundRepeat: "no-repeat",
                            backgroundPosition: "center center"
                        }
                    }, index);
                })
            })
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                src: "/images/img-mobile.jpg",
                alt: "Mobile img",
                layout: "fill",
                objectFit: "cover"
            })
        })
    });
}

// EXTERNAL MODULE: ./components/carousels/TextBannerCarousel.module.css
var TextBannerCarousel_module = __webpack_require__(48574);
var TextBannerCarousel_module_default = /*#__PURE__*/__webpack_require__.n(TextBannerCarousel_module);
// EXTERNAL MODULE: ./node_modules/react-markdown/lib/react-markdown.js + 126 modules
var react_markdown = __webpack_require__(55299);
;// CONCATENATED MODULE: ./components/carousels/TextBannerCarousel.tsx











function TextBannerCarousel(props) {
    var ref = (0,react.useState)(null), texts = ref[0], setTexts = ref[1];
    var ref1 = (0,react.useState)(3), timeTransition = ref1[0], setTimeTransition = ref1[1];
    var ref2 = (0,react.useState)(false), web = ref2[0], setWeb = ref2[1];
    var ref3 = (0,react.useState)(false), mobile = ref3[0], setMobile = ref3[1];
    (0,react.useEffect)(function() {
        (0,supabaseApi/* getMainTextBannerConfig */.uW)().then(function(config) {
            try {
                if (config && config[0] && config[0].value) {
                    var data = JSON.parse(config[0].value);
                    setTexts(data.msgList);
                    setTimeTransition(data.timeTransition);
                    setWeb(data.checkWeb);
                    setMobile(data.checkMobile);
                }
            } catch (error) {
                setTexts(null);
            }
        });
    }, []);
    var canRender = function() {
        if (props.isMobile) {
            return mobile;
        } else {
            return web;
        }
    };
    return texts && (texts === null || texts === void 0 ? void 0 : texts.length) > 0 && canRender() ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Container_Container/* default */.Z, {
        className: (TextBannerCarousel_module_default()).container,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
            slidesPerView: "auto",
            autoplay: {
                delay: texts.length === 1 ? 3600 * 1000 : 1000 * timeTransition,
                disableOnInteraction: false
            },
            loop: true,
            spaceBetween: 10,
            className: (TextBannerCarousel_module_default()).swiper,
            modules: [
                swiper_esm/* Autoplay */.pt
            ],
            children: texts === null || texts === void 0 ? void 0 : texts.map(function(msg, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                    className: (TextBannerCarousel_module_default()).slide,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (TextBannerCarousel_module_default()).msg,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_markdown/* ReactMarkdown */.D, {
                            children: msg
                        })
                    })
                }, index);
            })
        })
    }) : null;
}

;// CONCATENATED MODULE: ./lib/gtag.ts
var GA_TRACKING_ID = "G-VXHXJKMDP3" || 0;
var GTM_TRACKING_ID = "PS7VXFL" || 0;
// https://developers.google.com/analytics/devguides/collection/gtagjs/pages
var pageview = function(url) {
    window.gtag("config", GA_TRACKING_ID, {
        page_path: url
    });
};
// https://developers.google.com/analytics/devguides/collection/gtagjs/events
var gtag_event = function(param) {
    var action = param.action, category = param.category, label = param.label, value = param.value;
    window.gtag("event", action, {
        event_category: category,
        event_label: label,
        value: value
    });
};

// EXTERNAL MODULE: ./components/art/snow.module.css
var snow_module = __webpack_require__(60556);
var snow_module_default = /*#__PURE__*/__webpack_require__.n(snow_module);
;// CONCATENATED MODULE: ./components/art/snow.tsx


function SnowArt() {
    var SNOW_ENABLED = "false" || 0;
    if (SNOW_ENABLED === "false") return null;
    else {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (snow_module_default()).tpl_snow,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {})
            ]
        });
    }
}

;// CONCATENATED MODULE: ./pages/index.tsx





















var Home = function() {
    var router = (0,next_router.useRouter)();
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var isMobile = (0,useMediaQuery/* default */.Z)("(max-width:".concat(constants/* MOBILE_WIDTH_LIMIT */.x9, "px)"));
    var user = supabaseClient/* default.auth.user */.Z.auth.user();
    (0,react.useEffect)(function() {
        supabaseClient/* default.auth.onAuthStateChange */.Z.auth.onAuthStateChange(function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(event) {
                return (0,tslib_es6.__generator)(this, function(_state) {
                    if (event == "PASSWORD_RECOVERY") {
                        router.push("/reset_password");
                    }
                    return [
                        2
                    ];
                });
            });
            return function(event) {
                return _ref.apply(this, arguments);
            };
        }());
    }, []);
    (0,react.useEffect)(function() {
        (0,supabaseApi/* getUserRole */.Rg)(user === null || user === void 0 ? void 0 : user.email).then(function(data) {
            if ((data === null || data === void 0 ? void 0 : data.role_id) === constants/* BUSINESS_USER_ROLE */.ko) {
                router.push("/business");
            }
        });
    }, []);
    var checkStatistics = function() {
        var cookies = document.cookie.split(";");
        var cookieToCheck = cookies.find(function(cookie) {
            return cookie.includes("statistics");
        });
        if (cookieToCheck && cookieToCheck.split("=")[1] === "true") return true;
        return false;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (Home_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TextBannerCarousel, {
                isMobile: isMobile
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: t("pages.home.title")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: t("seo.meta_desc.home")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                        dangerouslySetInnerHTML: {
                            __html: "(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':\n            new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],\n            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=\n            'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);\n            })(window,document,'script','dataLayer','GTM-".concat(GTM_TRACKING_ID, "');")
                        }
                    }),
                    checkStatistics() && /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                        async: true,
                        src: "https://www.googletagmanager.com/gtag/js?id=".concat(GA_TRACKING_ID)
                    }),
                    checkStatistics() && /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                        dangerouslySetInnerHTML: {
                            __html: "\n              window.dataLayer = window.dataLayer || [];\n              function gtag() { dataLayer.push(arguments); }\n              gtag('js', new Date());\n              gtag('config', '".concat(GA_TRACKING_ID, "', {\n                page_path: window.location.pathname,\n              });\n            ")
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
                className: (Home_module_default()).main,
                style: {
                    minHeight: "calc(100vh - 380px)",
                    width: "100%"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SnowArt, {}),
                    isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(MainMobileCarousel, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(UpdatePage, {})
                        ]
                    }) : // calc(-60px + 100%)
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Home_module_default()).carrousel_banner,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Carousel, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LogosCarousel, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Home_module_default()).carrousel_banner,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer, {})
            })
        ]
    });
};
/* harmony default export */ var pages = (Home);
Home.getLayout = function getLayout(page) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout/* default */.Z, {
        children: page
    });
};


/***/ }),

/***/ 60556:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"tpl_snow":"snow_tpl_snow__AT2OO","nieve":"snow_nieve__CiTz4","horiz":"snow_horiz__rkG4K","horiz2":"snow_horiz2__YkURT"};

/***/ }),

/***/ 75277:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"LogosCarousel_container__o8JLo","swiper":"LogosCarousel_swiper__2WgkY","slide":"LogosCarousel_slide__21MYg"};

/***/ }),

/***/ 41283:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"MainMobileCarousel_container__z8SnO","swiper":"MainMobileCarousel_swiper__3gRe0","slide":"MainMobileCarousel_slide__J7AfW"};

/***/ }),

/***/ 48574:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"TextBannerCarousel_container__gSqJD","swiper":"TextBannerCarousel_swiper__7FkPh","slide":"TextBannerCarousel_slide__fUiVl","msg":"TextBannerCarousel_msg__QAFZd"};

/***/ }),

/***/ 214:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"Home_container__bCOhY","main":"Home_main__nLjiQ","footer":"Home_footer____T7K","carrousel_banner":"Home_carrousel_banner__oNWpr"};

/***/ }),

/***/ 97489:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"swiper":"BannersCarousel_swiper__givS_","swiper__child":"BannersCarousel_swiper__child__vY36Q","slide":"BannersCarousel_slide__gGXH_","swiper__logos":"BannersCarousel_swiper__logos__eiC8m"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5242,435,5299,6154,9385,9560,7336,9774,2888,179], function() { return __webpack_exec__(48312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);